var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ hasMinWidth: !_vm.hasMinWidth },attrs:{"id":"app"}},[(_vm.view)?[(_vm.isRouterAlive)?_c('router-view'):_vm._e()]:_c('no-support')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }